var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcRefreshBold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 4c-4.45 0-8 3.582-8 8a1 1 0 1 1-2 0A9.98 9.98 0 0 1 12 2c3.298 0 5.767 1.379 7.392 2.734q.326.273.608.54v-1.77a1 1 0 1 1 2 0v4.5a1 1 0 0 1-1 1h-3.996a1 1 0 1 1 0-2h1.904a11 11 0 0 0-.798-.734C16.737 5.123 14.705 4 12 4m9 7a1 1 0 0 1 1 1c0 5.52-4.48 10-10 10-2.831 0-5.062-1.425-6.535-2.761a14 14 0 0 1-.466-.443v1.7a1 1 0 1 1-2 0v-4.5a1 1 0 0 1 1-1h4.068a1 1 0 1 1 0 2H6.042c.226.245.482.504.766.761C8.093 18.923 9.863 20 12 20c4.416 0 8-3.584 8-8a1 1 0 0 1 1-1",
  clipRule: "evenodd"
})));
export default SvgIcRefreshBold;